import React from 'react'
import { StarIcon } from './StarIcon'
import { CONSTANTS } from '../../utils/Constants'

export const RatingIcon = (props: any): React.ReactElement => {
    const { index, rating, hoverRating, onMouseEnter, onMouseLeave, onSaveRating } = props
  
    const fill = React.useMemo(() => {
      if ((hoverRating >= index) || (!hoverRating && rating >= index)) {
        return CONSTANTS['starHoverColor']
      } 
      return CONSTANTS['starColorDefault']
    }, [rating, hoverRating, index])
  
    return (
      <div
        className='cursor-pointer'
        onMouseEnter={() => onMouseEnter(index)}
        onMouseLeave={() => onMouseLeave()}
        onClick={() => onSaveRating(index)}
      >
        <StarIcon fill={fill} />
      </div>
    )
  }